import React, { useState, useEffect } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { Icon } from '@iconify/react';
import { Dropdown } from 'primereact/dropdown';
import { useAuth } from '../../../context/useAuth';
import api from '../../../services/apiIdz';

// CSS
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';

function NewGarantia({ showGarantia, handleAlert }) {

    const { token } = useAuth()
    const [showModalGarantia, setShowModalGarantia] = useState(false);

    const handleClose = () => {
        setShowModalGarantia(false);
    };

    useEffect(() => {
        if (showGarantia) {
            setShowModalGarantia(true);
        }
    }, [showGarantia])

    const [popupData, setPopupData] = useState({
        opcoes: '',
        atributo:  ''
    })


    const handlePopupData = (value, field) => {
        setPopupData({
            ...popupData,
            [field]: value
        })
    }

    const postGarantia = async () => {
        const dataToSend = {
            ...popupData,
            opcoes: [popupData.opcoes],
            atributo: 'garantia_vidro'
        };
       await api.post(`/api/atributos`, dataToSend, {
            headers: {
                'Authorization': process.env.REACT_APP_API_KEY,
                "Token": token
            }
        }).then(r => {
            console.log(r)

            if (typeof r.data == 'string') {
                handleAlert("Campos inválidos", r.data, "danger")
            } else {
                if (r.status == 200) {
                    handleAlert("Sucesso", "Os dados foram cadastrados com êxito.", "success")
                    handleClose()
                }
            }
        })
    }

    return (
        <>

            <Modal show={showModalGarantia} className="NewModelo">
                <Modal.Header >
                    <Modal.Title>Cadastro de Garantia</Modal.Title>
                    <Icon icon="ri:edit-fill"></Icon>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Garantia da Blindagem</Form.Label>
                            <Form.Control value={popupData["opcoes"]} onChange={(e) => { handlePopupData(e.target.value, "opcoes") }} type="text" placeholder="Informe a garantia da blindagem" ></Form.Control>
                        </Form.Group>
                        <Form.Group className="text-center">
                            <Button variant="primary" className="Btns ButtonPrimaryLight" onClick={postGarantia}>
                                Salvar
                            </Button>
                        </Form.Group>
                        <Form.Group className="text-center">
                            <Button variant="secondary" className="Btns ButtonLight" onClick={handleClose}>
                                Fechar
                            </Button>
                        </Form.Group>
                    </Form>
                </Modal.Body>
            </Modal>
            
        </>
    );
};

export default NewGarantia;
